module.exports = __webpack_public_path__ + "img/bjx.74b654c8.jpg";